<template>
<div class="RedeemCodeEdit ">
    <div class="padding-20 bgc">
        <div class="account-form form">
            <el-form :model="item" :rules="rules" ref="ruleForm" label-width="120px" class="demo-item" label-position="left">
                <div class="classes blod">基本属性</div>
                <el-form-item label="兑换码名称" prop="name" class="">
                    <el-input v-model.trim="item.name" placeholder="请输入兑换码名称" maxlength="20" show-word-limit clearable :disabled="item.status == 10 || item.status == 100"></el-input>
                </el-form-item>
                <el-form-item label="库存数" prop="stockcount" class="">
                    <div class="flexstart">
                        <el-input v-model.trim="item.stockcount" placeholder="请输入数量" clearable class="num" :disabled="item.status == 10 || item.status == 100"></el-input>
                        <div class="tip" style="line-height: 32px;">不超过1,000,000个 </div>
                    </div>
                </el-form-item>
                <el-form-item label="活动时间" prop="" class="">
                    <div class="flexstart">
                        <el-form-item label="" prop="begindate" class="">
                            <el-date-picker v-model="item.begindate" type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :disabled="item.status != 0"></el-date-picker>
                        </el-form-item>
                        <span style="margin: 0 10px 0 0;">至</span>
                        <el-form-item label="" prop="enddate" class="">
                            <el-date-picker v-model="item.enddate" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :disabled="item.status == 10 || item.status == 100"></el-date-picker>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label="商品有效期" prop="kmcexpiredays" class="date">
                    <el-radio-group v-model="item.kmcexpiretype" :disabled="item.status != 0">
                        <el-radio :label="1">永久有效</el-radio>
                        <el-radio :label="2">兑换后 <el-input v-model.trim="item.kmcexpiredays" placeholder="" class="day" :disabled="item.status != 0"></el-input> 天有效</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div class="classes blod">兑换权益</div>
                <el-button type="primary" plain @click="handleOpenDialog" :disabled="item.status != 0">选择商品</el-button>
                <div class="cms flexstart" v-if="item.kmcid">
                    <div class="img-box"><img :src="item.kmccoverurl" alt="" class="img"></div>
                    <el-popover placement="top" title="" trigger="hover" :content="item.kmcname" popper-class="RedeemCodeList-pop">
                        <div class="kmcname text-ellipse tc-gray"  slot="reference">{{item.kmcname}}</div>
                    </el-popover>
                    <div class="kmctype tc-gray">{{item.kmctypename}}</div>
                </div>
                <div class="kmc-tip tc-red">活动一旦开始，指定商品不能修改。</div>
            </el-form>
        </div>
    </div>
    <div class="btns bgc flexcenter">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submitForm" v-if="item.status == 0 || item.status == 1">提交</el-button>
    </div>
    <goodsListDialog ref="goodsListDialog" @setCourseQuesList="setCms"></goodsListDialog>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {uploadAsseTredeemCodeInfo, getAsseTredeemCodeInfo} from 'api/operateToolApi'
import GoodsListDialog from 'views/operateTool/redeemCode/components/goodsListDialog.vue'
export default {
    name: 'RedeemCodeEdit',
    data() {
        let validateNum = (rule, value, callback) => {
            value = value * 1
            if (value > 1000000)  {
                callback(new Error('库存数不能超过1,000,000'))
            } else if (this.stockcount && value < (this.stockcount * 1)) {
                callback(new Error('库存数只能追加'))
            } else {
                callback()
            }
        }
        let validateExpiredays = (rule, value, callback) => {
            if (this.item.kmcexpiretype == 2 && !value)  {
                callback(new Error('请输入商品有效期'))
            } else {
                callback()
            }
        }
        let validateBegindate = (rule, value, callback) => {
            if (new Date(value) > new Date(this.item.enddate))  {
                callback(new Error('开始时间不能早于结束时间'))
            } else {
                callback()
            }
        }
        let validateEnddate = (rule, value, callback) => {
            if (new Date(value) < new Date(this.item.begindate))  {
                callback(new Error('结束时间不能晚于开始时间'))
            } if(new Date(value)< new Date()) {
                callback(new Error('结束时间不能晚于当前时间'))
            } else {
                callback()
            }
        }
        return {
            param: {
                codeid: this.$route.query.codeid ? this.$route.query.codeid : ''
            },
            stockcount: null,
            item: {
                name: '', // 兑换码名称
                stockcount: '', // 兑换码库存数
                begindate: '', // 活动开始时间(yyyy-MM-dd HH:mm:ss)
                enddate: '', // 活动结束时间(yyyy-MM-dd HH:mm:ss)
                kmcexpiretype: 1, // 兑换商品使用期限类型：1永久有效2兑换后N天有效
                kmcexpiredays: '', // 兑换商品使用期限-天：兑换后N天有效
                kmcid: '', // 媒资的id
                kmctype: '', // 媒资类型
                kmctypename: '',
                kmcname: '',
                kmccoverurl: '',
                status: 0, // 1进行中、0未开始、10已结束、100已删除
            },
            rules: {
                name: [
                    {required: true, message: '请输入兑换码名称', trigger: 'blur'},
                ],
                begindate: [
                    {required: true, message: '请选择活动开始时间', trigger: 'blur'},
                    {validator: validateBegindate, trigger: 'blur'}
                ],
                enddate: [
                    {required: true, message: '请选择活动结束时间', trigger: 'blur'},
                    {validator: validateEnddate, trigger: 'blur'}
                ],
                stockcount: [
                    {required: true, message: '请输入数量', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确数字', trigger: 'blur'},
                    {validator: validateNum, trigger: 'blur'}
                ],
                kmcexpiredays: [
                    {validator: validateExpiredays, trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        if (this.param.codeid) {
            this._getView()
        }
    },
    methods: {
        setCms(list) {
            let obj = list[0]
            this.item.kmcid = obj.kmcinnerid
            this.item.kmcname = obj.kmcname
            this.item.kmctype = obj.kmctype
            this.item.kmctypename = obj.kmctypename
            this.item.kmccoverurl = obj.coverurl
        },
        cancel() {
            this.$router.back()
        },
        handleOpenDialog() {
            this.$refs.goodsListDialog.openDialog([{kmcinnerid: this.item.kmcid}])
        },
        submitForm() {
            if (!this.item.kmcid) {
                this.$message.error('请选择商品')
                return false
            }
            this.$refs.ruleForm.validate((valid, name) => {
                if (valid) {
                    let item = this._.cloneDeep(this.item)
                    if (item.kmcexpiretype == 1) item.kmcexpiredays = 0
                    this._edit(item)
                }
            })
        },
        _edit(item) {
            this.setLoading(true)
            uploadAsseTredeemCodeInfo({
                data: item,
                success: data => {
                    this.$message.success('保存成功')
                    this.setIsRefresh(1)
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getAsseTredeemCodeInfo({
                data: this.param,
                success: data => {
                    if (data.data.kmcexpiretype == 1) data.data.kmcexpiredays = ''
                    this.item = data.data
                    this.stockcount = this.item.stockcount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setIsRefresh'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {GoodsListDialog}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.RedeemCodeEdit {
    font-size: 14px;
    .form{
        width: 800px;
        margin: 0;
    }
    .el-date-editor .el-range-separator{
        line-height: 26px;
    }
    .el-input{
        line-height: 32px;
        margin: 0 10px 0 0;
    }
    .date{
        .el-input{
            margin-left: 10px;
        }
    }
    .num{
        width: 260px;
    }
    .day{
        width: 68px;
    }
    .cms{
        background: #F5F7FA;
        font-size: 14px;
        margin-top: 15px;
        height: 30px;
        line-height: 30px;
        padding: 0 15px 0 0;
        box-sizing: border-box;
        width: 450px;
        .img-box{
            width: 53px;
            min-width: 53px;
            height: 30px;
            .img{
                width: 100%;
                height: 100%;
            }
        }
        .kmcname{
            flex-grow: 1;
            margin: 0 10px;
            width: 292px;
        }
        .kmctype {
            width: 70px;
            min-width: 70px;
            text-align: right;
        }
    }
    .kmc-tip{
        margin-top: 15px;
    }
    .btns{
        margin-top: 20px;
        height: 72px;
    }
}
.RedeemCodeList-pop{
    padding: 8px;
    min-width: auto;
    width: auto !important;
    max-width: 200px;
}
</style>
